import CheckboxList from './CheckboxList';

export default CheckboxList;



// WEBPACK FOOTER //
// ./src/components/CheckboxList/index.jsx